import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'app/config';
import { BankBranch } from 'app/models/customer';
import { PaginationResponse } from 'app/models/pagination-response';
import { CalculatorConst, CategoryItem, CityPostCode, States, SystemConstValues } from 'app/models/system-const-values';
import { lastValueFrom } from 'rxjs';
import { StorageService } from './storage.service';
import { UtilService } from './util.service';
import { FAQ } from 'app/models/faq';

@Injectable({ providedIn: 'root' })
export class SystemService {

    constructor(
        private http: HttpClient,
        private _utilService: UtilService,
        private _storageService: StorageService,
    ) { }

    async loadSystemConstValues() {
        try {
            if (this._storageService.getSessionToken()) {
                let details: any = await this.getSystemConstantValues();
                let detailsKey = Object.keys(details);
                const data: any = {};
                detailsKey.map((e: any) => {
                    if (!['ncdEntitlement', 'loanTenure', 'interestRate', 'telcoPrefix'].includes(e)) {
                        if (!data[e]) {
                            data[e] = [];
                        }
                        var tempData = details[e];
                        if (!['maritalStatus'].includes(e)) {
                            tempData = details[e].sort((a: string, b: string) => a.localeCompare(b));
                        }
                        tempData.map((element: any) => {
                            data[e].push({
                                optionViewKey: element,
                                value: element,
                            });
                        });
                    } else {
                        data[e] = details[e];
                    }
                });
                this._utilService.systemConstValuesObx.next(data);
            }
        } catch (e) {
            console.error(e);
        }
    }

    getSystemConstantValues(): Promise<CalculatorConst> {
        return lastValueFrom(this.http.get<CalculatorConst>(ApiUrls.CONSTANT_VALUES));
    }

    getCalculatorConst(): Promise<any> {
        return lastValueFrom(this.http.get<any>(ApiUrls.LOAN_CALCULATOR_CONST));
    }

    getMasterDropDownList(category: string, bankType: string | null = null): Promise<PaginationResponse<CategoryItem>> {
        var params = new HttpParams();
        params = params.append('category', category);
        if (bankType) {
            params = params.append('bankType', bankType);
        }
        return lastValueFrom(this.http.get<PaginationResponse<CategoryItem>>(ApiUrls.MASTER_DROPDOWN, { params }));
    }

    getBankBranch(bankType: string | null = null): Promise<Array<BankBranch>> {
        var params = new HttpParams();
        if (bankType) {
            params = params.append('bankType', bankType);
        }
        return lastValueFrom(this.http.get<Array<BankBranch>>(ApiUrls.BANK_BRANCH, { params }));
    }

    getState(): Promise<PaginationResponse<States>> {
        return lastValueFrom(this.http.get<PaginationResponse<States>>(ApiUrls.STATES));
    }

    getCityPostcode(stateId?: string): Promise<PaginationResponse<CityPostCode>> {
        var params = new HttpParams();
        if (stateId) {
            params = params.append('stateId', stateId);
        }
        return lastValueFrom(this.http.get<PaginationResponse<CityPostCode>>(ApiUrls.CITY_POSTCODE, { params }));
    }

    getFaq(params: HttpParams): Promise<FAQ[]> {
        return lastValueFrom(this.http.get<FAQ[]>(ApiUrls.FAQ_LIST, { params }));
    }
}
